/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForResourceLockSync extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForResourceLockSync");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForResourceLockSync.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForResourceLockSync>): BackgroundJobPayloadForResourceLockSync {
        let obj = Object.assign(new BackgroundJobPayloadForResourceLockSync(), model);
        BackgroundJobPayloadForResourceLockSync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForResourceLockSync>): BackgroundJobPayloadForResourceLockSync {
        if (!model) return null;
        return BackgroundJobPayloadForResourceLockSync.newInstance(<BackgroundJobPayloadForResourceLockSync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForResourceLockSync) {
        if (!obj) return;

        models.BackgroundJobPayloadForResourceLockSync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForResourceLockSync): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForResourceLockSync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service Account ID that needs to processed
     */
    service_account_id: string;

}
